let lockCount = 0;
let storedOverflow = '';
let storedPaddingRight = '';
let storedScrollY = 0;

export function lockBodyScroll(): void {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) {
    storedOverflow = document.body.style.overflow;
    storedPaddingRight = document.body.style.paddingRight;
    storedScrollY = window.scrollY;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
  lockCount++;
}

export function unlockBodyScroll(): void {
  if (typeof document === 'undefined' || lockCount === 0) return;
  lockCount--;
  if (lockCount === 0) {
    document.body.style.overflow = storedOverflow;
    document.body.style.paddingRight = storedPaddingRight;
    void storedScrollY;
  }
}

export function isBodyLocked(): boolean {
  return lockCount > 0;
}
